import React, { useEffect, useState } from 'react';
import { MessageCircle, Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const WelcomeMessageEditor = () => {
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/settings/customizer-welcome`)
      .then((r) => r.json())
      .then((data) => setMessage(data.message || ''))
      .catch(() => {});
  }, []);

  const handleSave = async () => {
    if (!message.trim()) {
      toast.error('Message cannot be empty');
      return;
    }
    setSaving(true);
    try {
      const res = await fetch(`${API_URL}/api/settings/customizer-welcome`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ message }),
      });
      if (!res.ok) throw new Error();
      toast.success('Welcome message updated — clients will see it on the customizer');
    } catch {
      toast.error('Failed to save message');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-testid="welcome-message-editor">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 bg-[#E6D7B3] rounded-lg flex items-center justify-center">
          <MessageCircle className="h-5 w-5 text-[#001B2A]" />
        </div>
        <div>
          <h2 className="font-serif font-bold text-[#001B2A]">Customizer Welcome Message</h2>
          <p className="text-xs text-gray-500">Shown at the top of the customizer page — tailor it for each client</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <input
          data-testid="welcome-message-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Hi! Pick your favorites and hit Submit — Johnnie"
          className="flex-1 px-4 py-2.5 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#7B1E2B] focus:border-transparent"
        />
        <button
          data-testid="welcome-message-save"
          onClick={handleSave}
          disabled={saving}
          className="flex items-center justify-center gap-2 px-5 py-2.5 bg-[#7B1E2B] text-white rounded-md text-sm font-semibold hover:bg-[#001B2A] transition-colors disabled:opacity-60"
        >
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          Save
        </button>
      </div>
    </div>
  );
};
